import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postPetFormThreeStart,
  postPetFormThreeSuccess,
  postPetFormThreeDataSuccess,
  postPetFormThreeFailure,
} from "../reducers/postPetFormThreeReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postPetFormThree = createAsyncThunk(
  "postPetFormThree",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postPetFormThreeStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/PetInsurance/SavePetSubDetails`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postPetFormThreeSuccess(responseData?.data?.result));
      thunkAPI.dispatch(postPetFormThreeDataSuccess(values));
      console.log(
        responseData?.data?.result,
        "<=========responseData?.data?.result"
      );
      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postPetFormThreeFailure(error.response.data.Message));

      if (error.response.data.Message) {
        thunkAPI.dispatch(postPetFormThreeFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postPetFormThreeFailure(error.response.data.status));
      }
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
